import { Animal, Consumption } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";
import { useAnimalConsumptionById, useAnimalConsumptionByMultipleIds } from "../../../Services/Agrisys_GqlDataCaller/ConsumptionCalls/consumptionSlice";

type AggregatedConsumption = {
  progressed: number;
  total: number;
};

type ConsumptionIndexed = Record<number, AggregatedConsumption>;

const emptyConsumption = (): AggregatedConsumption => ({
  progressed: 0,
  total: 0,
});

const groupByDay = (consumptions: Consumption[] = []): ConsumptionIndexed => {
  const byDay: ConsumptionIndexed = {};

  for (const c of consumptions) {
    const rawDay = c.milestoneDayOffset ?? 0;
    const day = rawDay * -1;

    if (!byDay[day]) {
      byDay[day] = { progressed: 0, total: 0 };
    }

    byDay[day].progressed += c.progressed ?? 0;
    byDay[day].total += c.total ?? 0;
  }

  return byDay;
};

export const useSingleConsumptionByMultipleIds = (animals: Animal[]) => {
  const consumptionEntities = useAnimalConsumptionByMultipleIds(animals.map(a => a.animal_id.toString()));

  const getConsumption = (animal_id: number): ConsumptionIndexed => {
    if (!animal_id) {
      return new Proxy({}, { get: () => emptyConsumption() }) as ConsumptionIndexed;
    }

    const consumptionEntity = Object.values(consumptionEntities).find(f => f.entity?.target_id.toString() === animal_id.toString());
    const rawEntity = consumptionEntity?.entity?.consumptions ?? [];
    const feedConsumptions = rawEntity.filter(c => c.componentId !== 1)
    const grouped = groupByDay(feedConsumptions);

    // Fallback
    return new Proxy(grouped, {
      get: (target, prop) => {
        const key = Number(prop);

        if (Number.isNaN(key)) {
          return undefined;
        }

        return target[key] ?? emptyConsumption();
      },
    }) as ConsumptionIndexed;
  };

  return getConsumption;
};